<template>
    <div class="look">
        <div>
            <el-page-header @back="close" content="查看专业信息表"></el-page-header>
        </div>
        <el-form :model="upsertForm" size="mini"  ref="upsertForm" label-width="80px" style="margin-top: 20px;" :inline="true" >
            <input type="hidden" :value="upsertForm.id">
              <el-form-item label="专业代码" prop="code">
                 <el-input size="mini" v-model="upsertForm.code" readonly  placeholder="请输入专业代码" auto-complete="off"></el-input>
             </el-form-item>
              <el-form-item label="专业名称" prop="name">
                 <el-input size="mini" v-model="upsertForm.name" readonly  placeholder="请输入专业名称" auto-complete="off"></el-input>
             </el-form-item>
        </el-form>
        <div  class="dialog-footer" style="text-align: center;">
            <el-button plain class="large" size="mini" @click="close">取 消</el-button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "lookSysMajor",
        props: ['id'],
        data(){
            return {
                upsertForm:{
                        id:'',
                        adminId:'',
                        adminName:'',
                        code:'',
                        name:'',
                        updateTime:'',
                        createTime:''
                }
            }
        },
        created(){
          axios({
                url:`${home}/sysMajor/look/lookSysMajorById/${this.id}`,
                method:'GET'
            }).then(res=>{
                Object.assign(this.upsertForm,res.data);
            }).catch(error=>{
                console.log(error);
            })
        },
        mounted(){

        },
        methods:{
            close(){
                this.$emit('update:visible');
            }
        }
    }
</script>

<style scoped lang="scss">
    .look{
        width:60%;
        margin: 20px 0 0 10px;
    }
</style>